import styled from 'styled-components';

interface IProps {
	color?: string;
}

export default styled.span<IProps>`
	${(props) =>
		props.color
			? `
		color: ${props.theme.colors[props.color]};
	`
			: ''}
`;
